import { ROUTE_NAMES } from '../../const/routeNames';

const routes = {};

export const cardActivationRoute = {
    loader: () => import('../../pages/CardActivation'),
    config: { isProtected: true },
};

export const setPinRoute = {
    loader: () => import('../../pages/SetPin'),
    config: { isProtected: true },
};

export const cardInfoRoute = {
    loader: () => import('../../pages/CardInfo'),
    config: { isProtected: true },
};

export const statusRoute = {
    loader: () => import('../../pages/ActivityResult'),
};

export const getRoutes = () => {
    routes[ROUTE_NAMES.CARD_ACTIVATION] = { ...cardActivationRoute };
    routes[ROUTE_NAMES.CARD_ACTIVATION_SET_PIN] = { ...setPinRoute };
    routes[ROUTE_NAMES.RESET_PIN] = { ...setPinRoute };
    routes[ROUTE_NAMES.CARD_INFO] = { ...cardInfoRoute };
    routes[ROUTE_NAMES.CARD_INFO_SET_PIN] = { ...setPinRoute };
    routes[ROUTE_NAMES.STATUS] = { ...statusRoute };

    return routes;
};
